module.exports = __webpack_public_path__ + "img/noticia-5.d769d37a.jpg";